import React from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaAngleRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import overlayTop from "../../assets/img/overlay-top.png";
import "./Footer.css";
import { useUser } from "../../context/UserContext";
import learnificLogo from "../../assets/img/learnific_white.png"; 

const Footer = () => {
  const { company, loading } = useUser();

  const quickLinks = [
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms & Condition", path: "/terms" },
    { name: "Refund Policy", path: "/refund-policy" },
    { name: "Regular FAQs", path: "/faq" },
  ];

  return (
    <>
      {/* Top Wave */}
      <div
        className="overlay-top-shape"
        style={{ backgroundImage: `url(${overlayTop})` }}
      ></div>

      {/* Footer Main */}
      <div className="container-fluid bg-dark text-white-50 py-3">
        <div className="container mt-3 pt-3">
          <div className="row">
            {/* Logo & About */}
            <div className="col-md-6 mb-3">
              <Link to="/" className="navbar-brand">
                <h1 className="mt-n2 text-uppercase text-white d-flex align-items-center">
                  <img
                    src={learnificLogo}
                    alt="Learnific Logo"
                    style={{ height: "40px", marginRight: "10px" }}
                  />
                  Learnific
                </h1>
              </Link>
              <p className="m-0">
                {company?.company_Name
                  ? `Welcome To ${company.company_Name}, Your Trusted Learning Platform.`
                  : "Your trusted learning platform."}
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="row">
            {/* Get In Touch */}
            <div className="col-md-4 mb-3">
              <h3 className="footer-heading">Get In Touch</h3>

              {loading ? (
                <p>Loading contact info...</p>
              ) : (
                <>
                  <p>
                    <FaMapMarkerAlt className="mr-2" />
                    {company?.address || "—"}
                  </p>
                  <p>
                    <FaPhoneAlt className="mr-2" />
                    {company?.contact_phone || "—"}
                  </p>
                  <p>
                    <FaEnvelope className="mr-2" />
                    {company?.contact_email || "—"}
                  </p>
                </>
              )}
            </div>

            {/* Our Company */}
            <div className="col-md-4 mb-3">
              <h3 className="footer-heading">Our Company</h3>
              <div className="d-flex flex-column justify-content-start">
                {[
                  { name: "Home", path: "/" },
                  { name: "About", path: "/about" },
                  { name: "Courses", path: "/courses" },
                  { name: "Contact", path: "/contact" },
                ].map(({ name, path }, i) => (
                  <Link key={i} className="footer-link" to={path}>
                    <FaAngleRight className="mr-2" />
                    {name}
                  </Link>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-md-4 mb-3">
              <h3 className="footer-heading">Support</h3>
              <div className="d-flex flex-column justify-content-start">
                {quickLinks.map(({ name, path }, i) => (
                  <Link key={i} className="footer-link" to={path}>
                    <FaAngleRight className="mr-2" />
                    {name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        className="container-fluid bg-dark text-white-50 border-top py-2"
        style={{ borderColor: "rgba(256, 256, 256, .1)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center text-md-left mb-2 mb-md-0">
              <p className="m-0">
                &copy; {new Date().getFullYear()}{" "}
                <Link className="text-white" to="/">
                  {company?.company_Name || "Learnific"}
                </Link>
                . All Rights Reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-right">
              <p className="m-0">
                Developed By{" "}
                <Link className="text-white" to="/" rel="noreferrer">
                  {company?.company_Name || "LEARNIFIC"}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
